import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useLoginPlaymove } from "../../../Hooks";
import { useTranslation } from "react-i18next";
import { getLocalizedRoutePath, ROUTE_KEYS } from "../../../routes/definitions";

export default function LoginFromToken() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const language = i18n.language;
  const token = searchParams.get("token");
  const refreshToken = searchParams.get("refreshToken");

  const { loginByToken } = useLoginPlaymove();

  useEffect(() => {
    const login = async () => {
      const loginPlaymovePath = getLocalizedRoutePath(ROUTE_KEYS.LOGIN_PLAYMOVE, language);
      if (!token || !refreshToken) {
        navigate(loginPlaymovePath);
        return;
      }

      try {
        loginByToken(token, refreshToken);
        navigate(getLocalizedRoutePath(ROUTE_KEYS.HOME, language));
      } catch (error) {
        console.error("Erro no login por token:", error);
        navigate(loginPlaymovePath);
      }
    };

    login();
  }, [token, refreshToken, navigate, language, loginByToken]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>Realizando login...</p>
    </div>
  );
}

